import type { Step } from '@bugbug/core/types/steps';
import type { Maybe } from '@bugbug/core/types/utils';

export type TemporaryStep<TStep extends Step = Step> = TStep & {
  isTemporary: true;
  atIndex: number;
};

export const isTemporaryStep = (step: Step | TemporaryStep): step is TemporaryStep =>
  (step as TemporaryStep).isTemporary === true;

// TODO: A type valid with BE response should be defined and replaced here
export type DefaultParams = Record<string, string | string[]>;

export interface DefaultStepParams<T extends Step['type']> {
  type: T;
  params: DefaultParams;
}

export type DefaultStepsParamsList = DefaultStepParams<Step['type']>[];

export type GroupedStepsParams = {
  [TStepType in Step['type']]?: Partial<DefaultParams>[];
};

export type CreateOrUpdateStepFormData<TStep extends Step> = Omit<TStep, 'value'> & {
  value?: TStep['type'] extends 'uploadFile' ? Maybe<File> : Maybe<string>;
};

export type CreateOrUpdateStepDto<TStep extends Step> = Omit<TStep, 'value'> & {
  value: Maybe<string>;
  projectArtifactId: Maybe<string>;
};
